//#region src/menu_item_display_style.ts
let MenuItemDisplayStyle = /* @__PURE__ */ function(MenuItemDisplayStyle) {
	MenuItemDisplayStyle[MenuItemDisplayStyle["NameAndDescription"] = 0] = "NameAndDescription";
	MenuItemDisplayStyle[MenuItemDisplayStyle["NameAndImage"] = 1] = "NameAndImage";
	MenuItemDisplayStyle[MenuItemDisplayStyle["Wide"] = 2] = "Wide";
	MenuItemDisplayStyle[MenuItemDisplayStyle["NameDescriptionAndImage"] = 3] = "NameDescriptionAndImage";
	return MenuItemDisplayStyle;
}({});
//#endregion
export { MenuItemDisplayStyle };

//# sourceMappingURL=menu_item_display_style.js.map